// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.91.0/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.91.0/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#venusUI {
  /**
   * Usage:
   *    p { .withBorder() } => p { border: @box-border }
   *    p { .withBorder(@border: @border) } => p { border: @border }
   *    p { .withBorder(true; @border) } => p { border: @border }
   *    p { .withBorder(left top) } => p { border-left: @box-border; border-top: @box-border; }
   *    p { .withBorder(left top; @border) } => p { border-left: @border; border-top: @border; }
   */
}
.n-stepper-input__button {
  flex-shrink: 0;
}
.n-stepper-input__button:disabled {
  opacity: 0.5;
  background-color: var(--color-content-disabled);
}
.n-stepper-input__input {
  font-family: 'IBM Plex Sans';
  text-align: right;
}
.n-stepper-input__input--size-lg {
  font-size: 24px;
}
.n-stepper-input__input--size-md {
  font-size: 14px;
  line-height: 18px;
}
.n-stepper-input__input:focus {
  outline: none;
}
.n-stepper-input__input-wrapper {
  font-family: 'IBM Plex Sans';
  overflow: hidden;
}
.n-stepper-input__input-wrapper--size-lg {
  font-size: 24px;
}
.n-stepper-input__input-wrapper--size-md {
  font-size: 18px;
}
.n-stepper-input__suffix {
  background: var(--color-input-background);
}
.n-stepper-input__suffix--size-lg {
  padding: 8px 16px;
}
.n-stepper-input__suffix--size-md {
  padding: 4px 8px;
}
`, "",{"version":3,"sources":["webpack://./src/neptune-app/libs/shared/venus/ui/less/mixins/decorators.less","webpack://./src/neptune-app/libs/shared/venus/ui/components/stepper-input/StepperInput.less"],"names":[],"mappings":"AAEA;ECDE;;;;;;;IAOE;AACJ;AANE;EACE,cAAA;AAQJ;AANI;EACE,YAAA;EACA,+CAAA;AAQN;AAJE;EAWE,4BAAA;EACA,iBAAA;AAJJ;AANM;EACE,eAAA;AAQR;AANM;EACE,eAAA;EACA,iBAAA;AAQR;AADI;EACE,aAAA;AAGN;AAAI;EACE,4BAAA;EASA,gBAAA;AANN;AADQ;EACE,eAAA;AAGV;AADQ;EACE,eAAA;AAGV;AAIE;EAUE,yCAAA;AAXJ;AAGM;EACE,iBAAA;AADR;AAGM;EACE,gBAAA;AADR","sourcesContent":["@import \"../variables.less\";\n\n#venusUI {\n\n  /**\n   * Usage:\n   *    p { .withBorder() } => p { border: @box-border }\n   *    p { .withBorder(@border: @border) } => p { border: @border }\n   *    p { .withBorder(true; @border) } => p { border: @border }\n   *    p { .withBorder(left top) } => p { border-left: @box-border; border-top: @box-border; }\n   *    p { .withBorder(left top; @border) } => p { border-left: @border; border-top: @border; }\n   */\n  .withBorder(@sides: true; @border: @box-border ) {\n    .setBorder(@side) when (@side) {\n      border: @border;\n    }\n    .setBorder(@side) when (@side = left), (@side = right), (@side = top), (@side = bottom){\n      border-@{side}: @border;\n    }\n    each(@sides, {\n      .setBorder(@value);\n    });\n  }\n\n  .withBorderRadius(@radius: @box-border-radius) {\n    border-radius: @radius;\n  }\n\n  .withShadow(@shadow: @box-shadow) {\n    box-shadow: @shadow;\n  }\n}\n","@import \"~venus\";\n\n.n-stepper-input {\n  &__button {\n    flex-shrink: 0;\n\n    &:disabled {\n      opacity: 0.5;\n      background-color: var(--color-content-disabled);\n    }\n  }\n\n  &__input {\n    &--size {\n      &-lg {\n        font-size: @fontSize-xl;\n      }\n      &-md {\n        font-size: @fontSize-sm;\n        line-height: @fontSize-md;\n      }\n    }\n\n    font-family: @IBMPlexSans;\n    text-align: right;\n\n    &:focus {\n      outline: none;\n    }\n\n    &-wrapper {\n      font-family: @IBMPlexSans;\n      &--size {\n        &-lg {\n          font-size: @fontSize-xl;\n        }\n        &-md {\n          font-size: @fontSize-md;\n        }\n      }\n      overflow: hidden;\n    }\n  }\n\n  &__suffix {\n    &--size {\n      &-lg {\n        padding: @layoutUnit-sm @layoutUnit-md;\n      }\n      &-md {\n        padding: @layoutUnit-xs @layoutUnit-sm;\n      }\n    }\n\n    background: var(--color-input-background);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
